import { i18nConstants } from '../_constants';
import { StoreDispatchType } from "../_library";


export const i18nActions = {
    changeLanguage,
    labelsFetched,
    labelSaved,
    setLabelEditMode,
    setEditingLabelKey
};

function changeLanguage(lang: string) {
    return (dispatch: StoreDispatchType) => {
        dispatch((data => {
            return { type: i18nConstants.CHANGE_LANGUAGE, data }
        })({lang}));
    };
}

function labelsFetched(labels: { [lang: string]: { [key: string]: string } }) {
    return { type: i18nConstants.LABELS_FETCHED, data: { labels } };
}

function labelSaved(key: string, values: { [lang: string]: string }) {
    return { type: i18nConstants.LABEL_SAVED, data: { key, values } };
}

function setLabelEditMode(editMode: boolean) {
    return { type: i18nConstants.SET_LABEL_EDIT_MODE, data: { editMode } };
}

function setEditingLabelKey(key: string | null) {
    return { type: i18nConstants.SET_EDITING_LABEL_KEY, data: { key } };
}
